module.exports = __webpack_public_path__ + "img/p1.caa6b746.png";